import basic from "./basic.json";
import layout from "./layout.json";
import eventTypeString from "./eventTypeString.json";
import eventReport from "./eventReport.json";
import login from "../../pages/Login/locales/zh.json";
import fleetMap from "../../pages/FleetMap/locales/zh.json";
import eventCenter from "../../pages/EventCenter/locales/zh.json";
import playback from "../../pages/Playback/locales/zh.json";
import settings from "../../pages/Settings/locales/zh.json";
import liveStream from "../../pages/LiveStream/locales/zh.json";
import installApp from "../../components/InstallAppButton/locales/zh.json";
import notifications from "../../pages/Notifications/locales/zh.json";
import home from "../../pages/Home/locales/zh.json";
import periodicReport from "../../pages/PeriodicReport/locales/zh.json";
import changePassword from "../../pages/ChangePassword/locales/zh.json";

export const zh = {
  ...basic,
  ...layout,
  ...eventTypeString,
  ...eventReport,
  ...login,
  ...fleetMap,
  ...eventCenter,
  ...playback,
  ...settings,
  ...liveStream,
  ...installApp,
  ...notifications,
  ...home,
  ...periodicReport,
  ...changePassword,
};
